import { makeAutoObservable } from "mobx";
import { BaseSearchObject, SearchObject } from "app/common/Model/SearchObject";
import {
    getAllDrug,
    getDrugSyncInventory,
    pageDrugInventory,
    pagingDrug,
} from 'app/services/DrugService';

import { toast } from "react-toastify";
import { getAllDrugGroup } from "app/services/DrugGroupService";
import { checkSearchObject } from "app/common/LocalFunction";
import { pagingStoreConfig } from "app/services/StoreConfigService";
import { pagingMedicalSupply } from "app/services/MedicalSupplyService";
import { PRODUCT_TYPE_STORE } from "app/common/LocalConst";

export default class DrugStoreInventory {

    openDrugSyncInventory = false;
    listAllDrugGroup = [];
    listAllDrug = []
    listAllMedicalSupply = []
    listAllStoreConfig = []
    searchProduct = {
        ...new BaseSearchObject(),
        productType: PRODUCT_TYPE_STORE?.[0]?.value
    }
    searchDrug = {
        drugGroupId: null,
        storeCode: null,
        drugId: null,
        isCheckInventory: true,
        getPackageInventory: true,
        biddingType: null,
        ...new BaseSearchObject()
    }
    listData = []
    constructor() {
        makeAutoObservable(this);
    }

    pagingDrug = () => {
        pageDrugInventory(this.searchDrug)
            .then(({ data }) => {
                this.listData = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }
    pagingProduct = () => {
        pagingDrug(this.searchProduct)
            .then(({ data }) => {
                this.listData = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    getAllDrug = () => {
        pagingDrug({ pageIndex: 1, pageSize: 1000 })
            .then(({ data }) => this.listAllDrug = data.content)
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            });
    }
    getAllMedicalSupply = () => {
        pagingMedicalSupply({ pageIndex: 1, pageSize: 1000 })
            .then(({ data }) => this.listAllMedicalSupply = data.content)
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            });
    }
    getAllStoreConfig = () => {
        pagingStoreConfig({ pageIndex: 1, pageSize: 1000 })
            .then(({ data }) => this.listAllStoreConfig = data.content)
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            });
    }

    getAllDrugGroup = async () => {
        try {
            const { data } = await getAllDrugGroup()
            this.listAllDrugGroup = data
        } catch (error) {
            toast.error("Lấy dữ liệu nhóm thuốc có lỗi");
        }
    }



    handleChangeFormSearch = (searchDrug) => {
        this.searchDrug = checkSearchObject(this.searchDrug, searchDrug);
        this.pagingDrug();
    }
    handleChangeFormSearchProduct = (searchDrug) => {
        this.searchProduct = { ...this.searchProduct, ...searchDrug }
        this.pagingProduct()
    }

    handleSearchDrugStore = async (obj) => {
        try {
            const { data } = await pageDrugInventory(obj)
            this.searchDrug = obj
            this.listData = data
        } catch (error) {
            toast.error("Lỗi tìm kiếm");
        }
    }
    //end
    handleSaveDrugSyncInventory = (data, { setSubmitting }) => {
        getDrugSyncInventory(data).then(() => {
            this.openDrugSyncInventory = false;
            toast.success("Đồng bộ tồn kho thành công")
            this.pagingDrug()
        }).catch((err) => {
            toast.error("Đồng bộ tồn kho thất bại")
        }).finally(() => {
            setSubmitting(false)
        })
    }
    handleOpenDrugSyncInventory = () => {
        this.openDrugSyncInventory = true
    }

    handleCloseDrugSyncInventory = () => {
        this.openDrugSyncInventory = false
    }


    reset = () => {
        this.searchDrug = {
            drugGroupId: null,
            storeCode: null,
            drugId: null,
            isCheckInventory: true,
            getPackageInventory: true,
            biddingType: null,
            ...new BaseSearchObject()
        }
        this.searchProduct = {
            ...new BaseSearchObject(),
            productType: PRODUCT_TYPE_STORE?.[0]?.value
        }

        this.listData = {}
        this.openDrugSyncInventory = false
    }
}